module.exports = __webpack_public_path__ + "static/media/Q_2_3.ffcb9a90.jpg";